<div class="row">
  <div class="first-column">
    <div class="content">
      <div *ngIf="hideToggleButton" class="icon-wrapper">
        <i2g-icon class="lock-icon" name="lock" size="custom"></i2g-icon>
      </div>

      <i2g-icon
        *ngIf="icon"
        class="icon"
        [icon]="icon"
        (click)="clickIcon.emit()"
      >
      </i2g-icon>

      <label
        class="toggle-label field-label"
        [class.sr-text]="hideLabel"
        [attr.data-e2e-id]="labelE2eId"
      >
        {{ label }}
      </label>

      <div class="children">
        <ng-content></ng-content>
      </div>
    </div>

    <p class="value">
      {{ value || emptyText }}
    </p>
  </div>

  <a class="setup-text" (click)="setupClicked()">
    {{ value ? editText : addText }}
  </a>
</div>

<div *ngIf="showDivider" class="divider"></div>
